<div class="form-check form-switch">
  <input
    class="form-check-input pointer"
    type="checkbox"
    role="switch"
    id="flexSwitchCheckDefault"
    [ngClass]="{ alwaysActivated: 'alwaysActivated' }"
    [checked]="checked"
    [disabled]="disabled"
    [attr.aria-checked]="checked"
    (change)="onChange($event)"
  />
  <label *ngIf="label" class="form-check-label" for="flexSwitchCheckDefault">
    {{ label }}
  </label>
</div>
